import Vue from 'vue'
import VueRouter, { RouteConfig, NavigationGuardNext, Route } from 'vue-router'
import Login from '../views/Login.vue'
import TransferPlanning from '../views/Planning/TransferPlanningCR.vue'
import TransferPlanningPJ from '../views/PlanningPJ/TransferPlanningPJ.vue'
import InspectionPlan from '../views/Report/InspectionPlan.vue'
import TrackingTransfer from '../views/Report/TrackingTransfer.vue'
import Hierarchy from '../views/Report/Hierarchy.vue'
import BankCredit from '../views/Report/BankCredit.vue'

import EmailTransfer from '../views/ViewData/EmailTransfer.vue'
import EmailAlertSummaryTransfer from '../views/ViewData/EmailAlertSummaryTransfer.vue'
import UnitTransfered from '../views/ViewData/UnitTransfered.vue'
import EmailTransferSummary from '../views/ViewData/EmailTransferSummary.vue'
import EmailAlertDaily from '../views/ViewData/EmailAlertDaily.vue'
import EmailAlertSevenInspection from '../views/ViewData/EmailAlertSevenInspection.vue'
import EmailTransferDetail from '../views/ViewData/EmailTransferDetail.vue'
import { AuthenticateApi } from "@/api"

Vue.use(VueRouter)

const groupWithOutUserTrackingSystem = [
	{
		path: '/viewdata/emailtransfer',
		name: 'ReportEmailTransfer',
		component: EmailTransfer,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/emailalertsummarytransfer',
		name: 'EmailAlertSummaryTransfer',
		component: EmailAlertSummaryTransfer,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/unittransfered',
		name: 'UnitTransfered',
		component: UnitTransfered,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/emailtransfersummary',
		name: 'EmailTransferSummary',
		component: EmailTransferSummary,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/emailalertdaily',
		name: 'EmailAlertDaily',
		component: EmailAlertDaily,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/emailalertseveninspection',
		name: 'EmailAlertSevenInspection',
		component: EmailAlertSevenInspection,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	},
	{
		path: '/viewdata/emailtransferdetail',
		name: 'EmailTransferDetail',
		component: EmailTransferDetail,
		meta: { requiresAuth: true, portal: 'withOutUserTracking' }
	}
]

const groupUserTrackingSystem = [
	{
		path: '/planning/transfercr',
		name: 'TransferPlanningCR',
		component: TransferPlanning,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
	{
		path: '/planning/transferpj',
		name: 'TrackingTransferPJ',
		component: TransferPlanningPJ,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
	{
		path: '/report/trackingtransfer',
		name: 'TrackingTransfer',
		component: TrackingTransfer,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
	{
		path: '/report/inspectionplan',
		name: 'InspectionPlan',
		component: InspectionPlan,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
	{
		path: '/report/hierarchy',
		name: 'Hierarchy',
		component: Hierarchy,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
	{
		path: '/report/bankcredit',
		name: 'BankCredit',
		component: BankCredit,
		meta: { requiresAuth: true, portal: 'userTracking' }
	},
]

const routes: Array<RouteConfig> = [
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '/.well-known/health',
		name: 'well-known',
		component: () => { "" }
	},
	{
		path: '/',
		name: 'empty',
		component: TransferPlanning,
		beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
			console.log('beforeEnter to', to)
			console.log('beforeEnter from', from)

			const firstDefault = localStorage.getItem("setDefaultPage") || ""
			const isAuth = localStorage.getItem('isAuth')
			const isUser = localStorage.getItem('isUser')
			console.log('=> isAuth <==', isAuth)
			console.log('=> isUser <==', isUser)
			console.log('=> default Page <==', firstDefault)

			if (isAuth === 'authorized' && isUser === 'withOutUserTracking') {
				next({
					path: '/login',
					query: { redirect: to.fullPath }
				})
			}

			if (isAuth === 'authorized' && isUser === 'userTracking') {
				next({ path: firstDefault })
				//next({ path: '/planning' })
			}
		},
		meta: { requiresAuth: true }
	},
	{ 
		path: '*',
		component: TransferPlanning,
		beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
			console.log('beforeEnter to', to)
			console.log('beforeEnter from', from)

			const isAuth = localStorage.getItem('isAuth')
			const isUser = localStorage.getItem('isUser')
			const firstDefault = localStorage.getItem("setDefaultPage") || ""
			console.log('=> isAuth <==', isAuth)
			console.log('=> isUser <==', isUser)
			console.log('=> default Page <==', firstDefault)

			if (isAuth === 'authorized' && isUser === 'withOutUserTracking') {
				next({
					path: '/login',
					query: { redirect: to.fullPath }
				})
			}

			if (isAuth === 'authorized' && isUser === 'userTracking') {
				next({ path: firstDefault })
				//next({ path: '/planning/' })
			}
		},
		meta: { requiresAuth: true }
	},
	...groupUserTrackingSystem,
	...groupWithOutUserTrackingSystem
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
	const isAuth = localStorage.getItem('isAuth')
	const isUser = localStorage.getItem('isUser')
	const firstDefault = localStorage.getItem("setDefaultPage") || ""
	console.log('=> isAuth', isAuth)
	console.log('=> isUser', isUser)
	console.log('=> toName', to.path)


	if (to.path !== '/login' && to.path !== '/login/' && to.path !== '/viewData') {
		localStorage.setItem('viewPathData', to.fullPath)
		console.log('localStorage.setItem viewPathData', to.fullPath)
	}


	if (to.name == "Login" && isUser === "userTracking") {
		
		if (isAuth === 'authorized') {
			next({
				path: firstDefault,
				//path: '/planning',
				query: { redirect: to.fullPath }
			})
		} 
	}

	console.log('groupUserTrackingSystem', groupUserTrackingSystem.map(x => x.path))
	console.log('groupUserTrackingSystem', to.path)
	console.log('=.', groupUserTrackingSystem.map(x => x.path).includes(to.path))
	if (to.name !== "Login" && isUser === "withOutUserTracking") {
		if (isAuth === 'authorized' && groupUserTrackingSystem.map(x => x.path).includes(to.path)) {
			next({ path: '/login/viewdata' })
		}
	}

	if (to.path === '/viewdata/' || to.path === '/viewdata') {
		if (isAuth === 'authorized') {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		}
	}
	
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (isAuth !== 'authorized') {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
			next()
		}
	} else {
		next() 
	}
})

export default router